import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AccessDeniedPage } from '../fallback/fallbackPage';
import { useAuth } from '../../auth/AuthContext';

const ProtectedRoute = ({ isAllowed, redirectPath = '/login', children }) => {
    const { isAuthenticated, authReady } = useAuth();
    const location = useLocation();

    // If isAllowed is explicitly true, check authentication
    if (isAllowed === true) {
        if (!authReady) return null; // Wait for auth to be ready
        if (!isAuthenticated) {
            return <Navigate to={redirectPath} state={{ from: location.pathname }} replace />;
        }
        return children ? children : <Outlet />;
    }

    if (!isAllowed) {
        return <AccessDeniedPage />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
